export default __webpack_public_path__ + "static/media/no-image.a33b48dd.jpg";